module.exports = __webpack_public_path__ + "于佳宁-d571ee3c.png";